import { useRef } from "react";
import ModalPop from "../../home/ModalPop";

const RightQuick = () => {
  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className="fixed right-2 bottom-16 lg:right-10 lg:bottom-32 w-fit h-fit z-10">
        <div className="grid grid-rows-2 gap-2 lg:gap-5">
          <button
            type="button"
            onClick={() => window.open("https://blog.naver.com/wnsl5107")}
            className=" relative w-fit h-fit max-w-14 lg:max-w-20 hover:-translate-y-3 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconBlog.png"
              alt="naverTalk"
              className="!relative w-full h-full object-contain"
            />
          </button>
          <button
            type="button"
            onClick={() => window.open("https://open.kakao.com/o/smGltdhi")}
            className=" relative w-fit h-fit max-w-14 lg:max-w-20 hover:-translate-y-3 transition-transform duration-200 hover:shadow-md rounded-full"
          >
            <img
              src="/images/iconKakao.png"
              alt="kakao"
              className="!relative w-full h-full object-contain"
            />
          </button>
        </div>
      </div>
    </>
  );
};

export default RightQuick;
